/* eslint-disable max-len */
import React from 'react';
import { Config } from '@leverege/plugin';
import { PortalOverlay, Content, Pane, Button, Flex } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class TRFormDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      breakpoint: this.getBreakPoint(window?.innerWidth)
    };
  }
  getBreakPoint(size) {
    return size > Config.get('ResponsiveUtility', 'smallBreakpoint', 1024) ? 'big' : 'small';
  }
  render() {
    const {
      variant,
      show,
      onClose
    } = this.props;
    const {
      breakpoint
    } = this.state;
    const vnt = variant || (breakpoint === 'small' ? 'mobileItemForm' : 'itemForm');
    return /*#__PURE__*/_jsx(PortalOverlay, {
      position: "center",
      show: show,
      closeOnEscape: false,
      closeOnDocumentClick: false,
      onClose: onClose,
      children: /*#__PURE__*/_jsx(Pane, {
        variant: vnt,
        children: this.renderContent()
      })
    });
  }
  renderContent() {
    const {
      onClose,
      onOkay,
      title,
      okay,
      cancel,
      okayVariant = 'primaryDestructive',
      children,
      headerVariant,
      bodyVariant,
      footerVariant,
      okayDisabled
    } = this.props;
    const {
      breakpoint
    } = this.state;
    const headerVnt = headerVariant || (breakpoint === 'small' ? 'mobileItemFormHeader' : 'itemFormHeader');
    const bodyVnt = bodyVariant || (breakpoint === 'small' ? 'mobileItemFormBody' : 'itemFormBody');
    const footerVnt = footerVariant || (breakpoint === 'small' ? 'mobileItemFormFooter' : 'itemFormFooter');
    const disableDialogStyle = {
      width: '256.5px',
      padding: '0px'
    };
    return /*#__PURE__*/_jsxs(Content, {
      relative: breakpoint === 'big',
      style: {
        width: '563px'
      },
      children: [/*#__PURE__*/_jsx(Content.Header, {
        variant: `${headerVnt}|formHeader`,
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: "dialogTitle",
          icon: "https://recovr-ui-assets.storage.googleapis.com/icon-theft-recovery.png",
          title: title
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        variant: `${bodyVnt}|formBody`,
        children: children
      }), /*#__PURE__*/_jsx(Content.Footer, {
        variant: `${footerVnt}|formButtons`,
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "rowM",
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "secondary",
            style: {
              ...disableDialogStyle
            },
            onClick: onClose,
            children: cancel
          }), /*#__PURE__*/_jsx(Button, {
            disabled: okayDisabled,
            variant: okayVariant,
            style: {
              ...disableDialogStyle
            },
            onClick: onOkay,
            children: okay
          })]
        })
      })]
    });
  }
}